<template>
  <div>
    <h4 class="subtitle is-4">{{name}}</h4>
    <draggable
      v-model="itemListProxy"
      :options="{handle: '.drag-handle'}"
      :move="evt => $emit('drag-move', evt)"
      @start="$emit('drag-start')"
      @end="$emit('drag-end')">
      <transition-group name="items" tag="div">
        <p v-for="(item, index) in itemListProxy" :key="item.externalId">
          <shopping-list-item
            :item="item"
            :checked="checked"
            drag-handle-class="drag-handle"
            @checkbox="$emit('checkbox', { index, item })"
            @change="value => $emit('change', index, item, value)"
            @delete="$emit('delete', index, item)" />
        </p>
      </transition-group>
    </draggable>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import ShoppingListItem from './ShoppingListItem';

export default {
  name: 'shoppingListItemList',
  props: ['name', 'checked', 'value'],
  data() {
    return {
    };
  },
  computed: {
    itemListProxy: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  components: {
    ShoppingListItem,
    draggable,
  },
};
</script>

<style lang="sass" scoped>
.items-leave-active
  text-decoration: line-through
  color: hsl(0, 0%, 96%)
  border: 0px
  transition: 0.5s
  opacity: 0

.items-enter
  opacity: 0

.items-enter-active  
  transition: all 0.5s

.items-move
  transition: transform 0.5s

</style>



// WEBPACK FOOTER //
// src/components/shopping-list/ShoppingListItemList.vue